import React from "react";
import axios from "axios";
import cx from "classnames";
import ReactTooltip from "react-tooltip";
import Dialog from "rc-dialog";
import moment from "moment";

import FormErrorHandler from "../../components/FormErrorHandler";
import FinalizeLegend from "./components/FinalizeLegend";
import { courseStateNames } from "./components/courseState";
import Loader from "../../components/Loader";
import { scrollToElem } from "../../functions";
import { buildCertificationTree, CertificateType, filterUnrelatedCertifications, isChildCertificationNode, isRootCertificationNode } from "../../utils/certifications";

export default class CoursesFinalize extends React.Component {
    constructor(props) {
        super(props);

        this.fallbackCloseDialog = this?.props?.fallbackCloseDialog && typeof this.props.fallbackCloseDialog === "function" ? this.props.fallbackCloseDialog : () => true;

        this.state = {
            loading: false,
            itemID: props.params.itemID !== undefined ? props.params.itemID : "",
            courseID: "",
            courseUUID: "",
            errorMessage: "",
            display_name: "",
            competence_profile: "",
            expected_students: "",
            contact_user: "",
            your_reference: "",
            students: [],
            activeChapter: 1,
            sendEmail: false,
            submitting: false,
            allStudentsChecked: true,
            allCertifications: [],
            selectedGlobalCertification: [],
            expandedParents: {},
            expandedParentsGlobal: {},
            confirmationPromptStepTwoVisible: false
        };
    }

    toggleExpand = (studentId, parentId) => {
        this.setState((prevState) => ({
            expandedParents: {
                ...prevState.expandedParents,
                [studentId]: {
                    ...(prevState.expandedParents[studentId] || {}),
                    [parentId]: !(prevState.expandedParents[studentId] && prevState.expandedParents[studentId][parentId])
                }
            }
        }));
    };

    toggleExpandGlobal = (parentId) => {
        this.setState((prevState) => {
            const currentExpandedState = prevState.expandedParentsGlobal["global"] && prevState.expandedParentsGlobal["global"][parentId];
            return {
                expandedParentsGlobal: {
                    ...prevState.expandedParentsGlobal,
                    ["global"]: {
                        ...(prevState.expandedParentsGlobal["global"] || {}),
                        [parentId]: !currentExpandedState
                    }
                }
            };
        });
    };

    // todo: this is out of date. /v1/certification-pass/ is not used anymore
    // downloadPassesPrintPDF = async () => {
    //     try {
    //         const payloadStudents = this.state.students
    //             .filter((s) => s.checkedForSubmit && !!s.selectedCertification && s.physicalPasses && s.physicalPasses.length > 0)
    //             .flatMap((student) =>
    //                 student.selectedCertification.map((certification) => ({
    //                     student_uuid: student.uuid,
    //                     certification_uuid: certification.value
    //                 }))
    //             );
    //
    //         const payload = {
    //             students: payloadStudents,
    //             trainer: this.state.trainer.name,
    //             quality_mark: this.state.trainer.qualitymark_number
    //         };
    //
    //         const res = await axios.post("/v1/certification-pass/", payload, { responseType: "blob" });
    //         const url = window.URL.createObjectURL(new Blob([res.data]));
    //         const link = document.createElement("a");
    //         link.href = url;
    //         const contentDisposition = res.headers["content-disposition"];
    //         let fileName = "certificate.pdf";
    //
    //         if (contentDisposition) {
    //             const fileNameMatch = contentDisposition.match(/filename="(.*)"/);
    //
    //             if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
    //         }
    //         link.setAttribute("download", fileName);
    //         document.body.appendChild(link);
    //         link.click();
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ submitting: true }, async () => {
            try {
                const postData = this.state.students
                    .filter((s) => s.checkedForSubmit && !!s.selectedCertification)
                    .flatMap((student) =>
                        student.selectedCertification.map((certification) => ({
                            user: student.uuid,
                            course: this.state.itemID,
                            competence_profile: certification.value,
                            physical_pass: student.physicalPasses.length > 0 && student.physicalPasses.some((pass) => pass.value === certification.value),
                            ...(!!this.state.sendEmail && { notify: true })
                        }))
                    );

                await axios.post("/v1/certifications/", postData);

                const selectedStudents = this.state.students.filter((s) => s.checkedForSubmit && !!s.selectedCertification);

                if (selectedStudents.some((student) => student.selected_insured || student.selected_employer_specific)) {
                    const combinedStudentOptions = selectedStudents.map((student) => {
                        return {
                            user: student.uuid,
                            ...(!!student.selected_insured && { insured: true }),
                            ...(!!student.selected_employer_specific && { employer_specific: true })
                        };
                    });

                    const transformedData = {
                        student_options: combinedStudentOptions
                    };

                    await axios.patch("/v1/courses/" + this.state.itemID + "/", transformedData);
                }

                // not needed download passes,
                // ToDo needed refactoring to generate physical pass only if it is selected
                // important: don't simply enable this, the used end point is out of date!
                // await this.downloadPassesPrintPDF();

                this.setState({ submitting: false });

                this.props.addGlobalMessage({
                    title: "Certificaten zijn aangemaakt voor de studenten die u heeft geselecteerd."
                });

                if (this.state.sendEmail) {
                    this.props.addGlobalMessage({
                        title: "Een e-mail waarin de studenten op de hoogte worden gesteld van hun certificaten is verzonden."
                    });
                }

                this.props.refreshStudents();
                this.props.courseDetailMutate();
                this.props.fallbackCloseDialog();
            } catch (error) {
                console.log(error);
                let errorMessage = error.response?.data;
                this.setState({
                    errorMessage: Array.isArray(errorMessage) ? errorMessage[0] : errorMessage,
                    submitting: false
                });
                scrollToElem(document.querySelector(".form-error"));
            }
        });
    };

    findHighestAvailableCertification = (certifications) => {
        const sortedCertifications = [...certifications].sort((a, b) => (b.competence_profile.uuid > a.competence_profile.uuid ? 1 : -1));
        let highestAvailable = null;

        for (let certification of sortedCertifications) {
            if (certification.available) {
                highestAvailable = [certification];

                const queue = [...certification.children];
                while (queue.length > 0) {
                    const currentCertification = queue.shift();
                    if (currentCertification.available) {
                        highestAvailable.push(currentCertification);
                    }

                    queue.push(...currentCertification.children);
                }

                break;
            } else {
                let highestChild = this.findHighestAvailableCertification(certification.children);
                if (highestChild) {
                    if (highestAvailable === null || highestChild[0].competence_profile.uuid > highestAvailable[0].competence_profile.uuid) {
                        highestAvailable = highestChild;
                    }
                }
            }
        }

        return highestAvailable;
    };

    getAllDescendants = (certification) => {
        let descendants = [
            {
                certificate_type: certification.competence_profile.certificate_type,
                parents: certification.competence_profile.parents,
                label: certification.competence_profile.name,
                value: certification.competence_profile.uuid
            }
        ];

        certification.children.forEach((child) => {
            descendants = [...descendants, ...this.getAllDescendants(child)];
        });

        return descendants;
    };

    getCourseData = () => {
        // todo: this data is passed via props.course and props.students!!!!
        //  do we really need to fetch it all again?

        this.setState({ loading: true }, async () => {
            const { data: courseData } = await axios.get("/v1/courses/" + this.state.itemID + "/");

            this.setState(
                {
                    courseInsuranceAvailable: courseData.insurance_available,
                    courseID: courseData.id,
                    courseUUID: courseData.uuid,
                    itemID: courseData.uuid,
                    trainer: courseData.trainer,
                    display_name: courseData.display_name,
                    competence_profile: courseData.competence_profile,
                    expected_students: courseData.expected_students,
                    contact_user: courseData.contact_user,
                    your_reference: courseData.your_reference,
                    course_state: courseData.state
                },
                async () => {
                    try {
                        const { data: studentsData } = await axios.get("/v1/courses/" + this.state.itemID + "/students/");

                        const students = studentsData.results
                            .filter((s) => !s.cancelled)
                            .map((s) => {
                                const tree = buildCertificationTree(filterUnrelatedCertifications(this.props.competenceProfile, s.available_certifications));

                                const highestCertification = this.findHighestAvailableCertification(tree);
                                let selectedCertification = [];
                                if (highestCertification?.length > 0) {
                                    selectedCertification = [
                                        highestCertification[0],
                                        ...(isRootCertificationNode(highestCertification[0]) && !highestCertification[0].competence_profile.repetition
                                            ? highestCertification[0].children.filter((c) => c.available)
                                            : [])
                                    ].map((c) => ({
                                        certificate_type: c.competence_profile.certificate_type,
                                        parents: c.competence_profile.parents,
                                        label: c.competence_profile.name,
                                        value: c.competence_profile.uuid
                                    }));
                                }

                                return {
                                    ...s,
                                    available_certifications_original: s.available_certifications,
                                    selectedCertification,
                                    checkedForSubmit: true,
                                    selected_insured: s.student_options.insured,
                                    selected_employer_specific: s.student_options.employer_specific,
                                    physicalPasses: []
                                };
                            });

                        const allCertifications = [];

                        // Make sure we only have unique certification (2 students could have the same one, this avoids putting both of them in the same array)
                        students?.forEach((student) => {
                            student.available_certifications?.forEach((certification) => {
                                if (!allCertifications.some((c) => c.competence_profile.uuid === certification.competence_profile.uuid))
                                    allCertifications.push(certification);
                            });
                        });

                        const expandedParents = {};

                        const setExpandedParents = (certifications, studentId, depth = 1) => {
                            certifications.forEach((certification) => {
                                if (!expandedParents[studentId]) {
                                    expandedParents[studentId] = {};
                                }

                                const isRepeaterCourse = certification.competence_profile.repetition;

                                if (!isRepeaterCourse && depth === 1) {
                                    expandedParents[studentId][certification.competence_profile.uuid] = true;
                                } else if (isRepeaterCourse && depth === 2) {
                                    expandedParents[studentId][certification.competence_profile.uuid] = true;
                                }

                                if (certification.children && certification.children.length > 0) {
                                    setExpandedParents(certification.children, studentId, depth + 1);
                                }
                            });
                        };

                        students.forEach((student) => {
                            const tree = buildCertificationTree(filterUnrelatedCertifications(this.props.competenceProfile, student.available_certifications));

                            setExpandedParents(tree, student.uuid);
                        });

                        this.setState({
                            expandedParents,
                            allCertifications,
                            students,
                            loading: false
                        });
                    } catch (error) {
                        console.error(error);
                        this.setState({
                            loading: false
                        });
                    }
                }
            );
        });
    };

    hasAvailableDescendant = (certification) => {
        if (certification.available) return true;

        for (let i = 0; i < certification.children?.length; i++) {
            if (this.hasAvailableDescendant(certification.children[i])) {
                return true;
            }
        }

        return false;
    };

    componentDidMount() {
        this.getCourseData();
    }

    checkAllStudents = () => {
        this.setState((state) => {
            const allStudentsChecked = !state.allStudentsChecked;

            const students = state.students.map((student) => ({
                ...student,
                checkedForSubmit: allStudentsChecked
            }));

            return { allStudentsChecked, students };
        });
    };

    studentChecked = (e, uuid) => {
        this.setState((state) => {
            const students = state.students.map((student) => (student.uuid === uuid ? { ...student, checkedForSubmit: e.target.checked } : student));

            return { students };
        });
    };

    studentInsuredChecked = (e, uuid) => {
        this.setState(
            (state) => {
                const students = state.students.map((student) =>
                    student.uuid === uuid
                        ? { ...student, selected_insured: e.target.checked, insurance_quote: e.target.checked ? student.insurance_quote : null }
                        : student
                );
                return { students };
            },
            () => {
                const student = this.state.students.find((s) => s.uuid === uuid);
                if (student) {
                    this.fetchInsuranceQuote([student]);
                }
            }
        );
    };

    studentEmployerSpecificChecked = (e, uuid) => {
        this.setState((state) => {
            const students = state.students.map((student) => (student.uuid === uuid ? { ...student, selected_employer_specific: e.target.checked } : student));
            return { students };
        });
    };

    checkPhysicalPass = (e, cert, uuid) => {
        const requestBody = [
            {
                user: uuid,
                competence_profile: cert.value,
                course: this.state.itemID,
                products: ["physical-pass-print"]
            }
        ];

        const getQuoteAndUpdateState = async () => {
            try {
                const response = await axios.post("/v1/certifications/quote/", requestBody);

                this.setState((state) => {
                    const students = state.students.map((student) => {
                        if (student.uuid === uuid) {
                            const physicalPasses = student.physicalPasses.map((pass) => {
                                if (pass.value === cert.value) {
                                    const studentQuote = response.data.find((quote) => quote.user.uuid === student.uuid && quote.competence_profile.uuid === cert.value);

                                    if (studentQuote) {
                                        pass.price = studentQuote.price;
                                        pass.currency = studentQuote.currency;
                                        if (studentQuote.error) pass.error = studentQuote.error;
                                    } else {
                                        pass.error = "Kon de prijs voor dit artile; niet krijgen";
                                    }
                                }
                                return pass;
                            });
                            return { ...student, physicalPasses };
                        }
                        return student;
                    });
                    return { students };
                });
            } catch (error) {
                console.error(error);
            }
        };

        if (e.target.checked) {
            this.setState((state) => {
                const students = state.students.map((student) =>
                    student.uuid === uuid
                        ? {
                              ...student,
                              physicalPasses: [...student.physicalPasses, { value: cert.value }]
                          }
                        : student
                );
                return { students };
            }, getQuoteAndUpdateState);
        } else {
            this.setState((state) => {
                const students = state.students.map((student) =>
                    student.uuid === uuid
                        ? {
                              ...student,
                              physicalPasses: student.physicalPasses.filter((pass) => pass.value !== cert.value)
                          }
                        : student
                );
                return { students };
            });
        }
    };

    handleChangeSelect = (e, uuid) => {
        const value = e.target.value;
        const isChecked = e.target.checked;

        this.setState((prevState) => {
            const students = prevState.students.map((student) => {
                if (student.uuid === uuid) {
                    let newSelectedCertification;
                    if (isChecked) {
                        const tree = buildCertificationTree(filterUnrelatedCertifications(this.props.competenceProfile, student.available_certifications));
                        const clickedCertification = this.findCertificationInTree(tree, value);

                        const directChildren = clickedCertification.children.map((c) => ({
                            certificate_type: c.competence_profile.certificate_type,
                            parents: c.competence_profile.parents,
                            label: c.competence_profile.name,
                            value: c.competence_profile.uuid
                        }));

                        newSelectedCertification = [
                            {
                                certificate_type: clickedCertification.competence_profile.certificate_type,
                                parents: clickedCertification.competence_profile.parents,
                                label: clickedCertification.competence_profile.name,
                                value: clickedCertification.competence_profile.uuid
                            },
                            ...(isRootCertificationNode(clickedCertification) && !clickedCertification.competence_profile.repetition ? directChildren : []),
                            ...student.selectedCertification
                        ];
                    } else {
                        const allDescendants = this.getAllDescendants(this.findCertificationInTree(student.available_certifications, value));
                        const allDescendantValues = allDescendants.map((c) => c.value);

                        newSelectedCertification = student.selectedCertification.filter((option) => !allDescendantValues.includes(option.value));
                    }

                    return {
                        ...student,
                        selectedCertification: newSelectedCertification
                    };
                } else {
                    return student;
                }
            });

            return { students };
        });
    };

    handleChangeGlobalSelect = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;

        this.setState((prevState) => {
            const selectedGlobalCertification = isChecked
                ? [...prevState.selectedGlobalCertification, { value, label: e.target.name }]
                : prevState.selectedGlobalCertification?.filter((certification) => certification.value !== value);

            const students = prevState.students.map((student) => {
                if (
                    student.available_certifications?.some((c) => c.competence_profile.uuid === value && c.available) ||
                    student.selectedCertification.some((c) => c.parents.includes(value))
                ) {
                    let newSelectedCertification;
                    if (isChecked) {
                        const clickedCertification = this.findCertificationInTree(
                            filterUnrelatedCertifications(this.props.competenceProfile, student.available_certifications),
                            value
                        );

                        const directChildren = clickedCertification.children.map((c) => ({
                            certificate_type: c.competence_profile.certificate_type,
                            parents: c.competence_profile.parents,
                            label: c.competence_profile.name,
                            value: c.competence_profile.uuid
                        }));

                        newSelectedCertification = [
                            {
                                certificate_type: clickedCertification.competence_profile.certificate_type,
                                parents: clickedCertification.competence_profile.parents,
                                label: clickedCertification.competence_profile.name,
                                value: clickedCertification.competence_profile.uuid
                            },
                            ...(isRootCertificationNode(clickedCertification) && !clickedCertification.competence_profile.repetition ? directChildren : []),
                            ...student.selectedCertification
                        ];
                    } else {
                        const allDescendants = this.getAllDescendants(this.findCertificationInTree(student.available_certifications, value));
                        const allDescendantValues = allDescendants.map((c) => c.value);

                        newSelectedCertification = student.selectedCertification.filter((option) => !allDescendantValues.includes(option.value));
                    }

                    return {
                        ...student,
                        selectedCertification: newSelectedCertification
                    };
                } else {
                    return student;
                }
            });

            return { selectedGlobalCertification, students };
        });
    };

    getAvailabilityReasonTooltipText = (data, available, type) => {
        let text = "";

        if (available) {
            text += `Deze certificering is beschikbaar door het behalen van:<br /><br />`;

            text += data.end_terms.map((item) => `- ${item.name} op ${item.latest_progress?.date}`).join("<br />");
        } else {
            text += `Deze certificering is niet beschikbaar door het niet behalen van:<br /><br />`;

            text += data.reasons
                ?.map((reason) => {
                    let reasonText = `<b>${reason.description}</b>`;
                    if ("end_terms" in reason) {
                        // this reason includes a list of end terms:
                        reasonText += "<br />" + reason.end_terms.map((endTerm) => `- ${endTerm.name}`).join("<br />");
                    }
                    return reasonText;
                })
                .join("<br />");
        }
        console.log("123");
        return text;
    };

    renderStudentCheckboxes = (availableCertifications, selectedCertification, uuid, handleChangeSelect) => {
        const certificationTree = buildCertificationTree(availableCertifications);
        return this.renderCertificationNodes(certificationTree, selectedCertification, uuid, handleChangeSelect);
    };

    findCertificationInTree = (tree, competence_profile) => {
        for (const node of tree) {
            if (node.competence_profile.uuid === competence_profile) {
                return node;
            }

            const result = this.findCertificationInTree(node.children, competence_profile);
            if (result) {
                return result;
            }
        }

        return null;
    };

    renderCertificationNodes = (certifications, selectedCertification, uuid, handleChangeSelect, isChild = false, depth = 1) => {
        console.log("222");
        const sortedCertifications = [...certifications].sort((a, b) => (a.available && !b.available ? -1 : 1));

        // Filter out certifications that are not related to the current profile
        const filteredCertifications = filterUnrelatedCertifications(this.props.competenceProfile, sortedCertifications);

        return filteredCertifications.map((certification) => {
            const isChecked = selectedCertification.some((option) => option.value === certification.competence_profile.uuid);
            const isRepeaterCourse = certification.competence_profile.repetition;

            const hasParentSelected = selectedCertification.some((option) => certification.competence_profile.parents.includes(option.value));

            const parentCertification = isChildCertificationNode(certification)
                ? filterUnrelatedCertifications(this.props.competenceProfile, this.state.allCertifications).find((cert) =>
                      certification.competence_profile.parents.includes(cert.competence_profile.uuid)
                  )
                : null;

            const hasGrandParentSelected = selectedCertification.some((option) => parentCertification?.competence_profile?.parents?.includes(option.value));

            const isParentRepeaterCourse = parentCertification ? parentCertification.competence_profile.repetition : false;

            const isParentAlreadyGenerated = parentCertification?.reasons?.some((reason) => reason.type === "already_certified");

            const isDisabled =
                !certification.available ||
                isParentAlreadyGenerated ||
                (hasParentSelected && depth === 3 && !isRepeaterCourse) ||
                ((hasParentSelected || hasGrandParentSelected) && [2, 3].includes(depth) && isRepeaterCourse);

            let checkColor;
            if (isChecked) {
                checkColor = "green";
            } else if (hasParentSelected && certification.children.length === 0) {
                checkColor = depth === 2 && isParentRepeaterCourse ? "grey" : "green";
            } else if (isParentAlreadyGenerated) {
                checkColor = "green";
            } else if ((hasParentSelected || hasGrandParentSelected) && [2, 3].includes(depth) && certification.competence_profile.repetition) {
                checkColor = "green";
            }

            const isGeneratedInAnotherCourse =
                certification.reasons?.some((reason) => reason.type === "already_certified") ||
                (certification.current_certification?.current_course === false && new Date(certification.current_certification?.expiration_date) < new Date());

            const { language, repetition, tags } = certification.competence_profile;
            return (
                <div key={certification.competence_profile.uuid} style={{ marginLeft: isChild ? "20px" : "0" }}>
                    <label
                        htmlFor={`student-option-${uuid}-${certification.competence_profile.uuid}`}
                        className="certification-name"
                        style={{ fontWeight: isChild ? "500" : "700" }}
                        title={`${language.toUpperCase()}, ${repetition ? "herhaling" : "geen herhaling"}, [${tags.join(", ")}]`}
                    >
                        <CertificateType type={certification.competence_profile.certificate_type} /> - {certification.competence_profile.name}
                    </label>
                    <label className="finalize-custom-checkbox" htmlFor={`student-option-${uuid}-${certification.competence_profile.uuid}`}>
                        {isGeneratedInAnotherCourse ? (
                            <>
                                <input disabled type="checkbox" id={`student-option-${uuid}-${certification.competence_profile.uuid}-already-certified`} />
                                <i className="fa fa-check checkmark-already-certified" style={{ color: "#999" }}></i>
                            </>
                        ) : (
                            <>
                                <input
                                    disabled={isDisabled}
                                    type="checkbox"
                                    id={`student-option-${uuid}-${certification.competence_profile.uuid}`}
                                    value={certification.competence_profile.uuid}
                                    name={certification.competence_profile.name}
                                    checked={isChecked}
                                    onChange={(e) => handleChangeSelect(e, uuid)}
                                />
                                <i className="fa fa-check finalize-custom-checkmark" style={{ color: checkColor }}></i>
                            </>
                        )}
                    </label>
                    <i
                        style={{ marginTop: "5px", width: "25px", height: "25px" }}
                        className="fa fa-info-circle"
                        data-tip
                        data-for={`tip-${uuid}-${certification.competence_profile.uuid}-availability-reason`}
                    />
                    <ReactTooltip html={true} id={`tip-${uuid}-${certification.competence_profile.uuid}-availability-reason`} effect="solid" place="right">
                        {this.getAvailabilityReasonTooltipText(certification, certification.available, certification.competence_profile.certificate_type)}
                    </ReactTooltip>
                    {certification.children.length > 0 && (
                        <i
                            style={{ marginLeft: "15px", marginTop: "5px", cursor: "pointer" }}
                            className={`fa fa-chevron-${
                                this.state.expandedParents[uuid] && this.state.expandedParents[uuid][certification.competence_profile.uuid] ? "up" : "down"
                            }`}
                            onClick={() => this.toggleExpand(uuid, certification.competence_profile.uuid)}
                        />
                    )}
                    {this.state.expandedParents[uuid] &&
                        this.state.expandedParents[uuid][certification.competence_profile.uuid] &&
                        this.renderCertificationNodes(certification.children, selectedCertification, uuid, handleChangeSelect, true, depth + 1)}
                </div>
            );
        });
    };

    renderGlobalCheckboxes = (allCertifications, selectedGlobalCertification, handleChangeGlobalSelect) => {
        const nestedCertifications = buildCertificationTree(allCertifications);

        const CertificationsList = ({ currentProfile, items, level = 0 }) => {
            if (items.length === 0) {
                return null;
            }

            items = filterUnrelatedCertifications(currentProfile, items);

            return (
                <>
                    {items.map((certification) => {
                        const isChecked = selectedGlobalCertification?.some(
                            (option) => option.value === certification.competence_profile.uuid || certification.competence_profile.parents.includes(option.value)
                        );
                        const hasChildren = certification.children && certification.children.length > 0;
                        // todo: if we are able to, we should move this component outside of this class
                        const parentExpanded =
                            this.state.expandedParentsGlobal["global"] && this.state.expandedParentsGlobal["global"][certification.competence_profile.uuid];

                        return (
                            <React.Fragment key={certification.competence_profile.uuid}>
                                <div style={{ marginLeft: `${level * 20}px` }} className="finalize-custom-checkbox-container">
                                    <label htmlFor={`global-option-${certification.competence_profile.uuid}`} className="certification-name">
                                        <CertificateType type={certification.competence_profile.certificate_type} /> - {certification.competence_profile.name}
                                    </label>
                                    <label className="finalize-custom-checkbox" htmlFor={`global-option-${certification.competence_profile.uuid}`}>
                                        <input
                                            disabled={selectedGlobalCertification?.some((option) => certification.competence_profile.parents.includes(option.value))}
                                            type="checkbox"
                                            id={`global-option-${certification.competence_profile.uuid}`}
                                            value={certification.competence_profile.uuid}
                                            name={certification.competence_profile.name}
                                            checked={isChecked}
                                            onChange={handleChangeGlobalSelect}
                                        />
                                        <i className="fa fa-check finalize-custom-checkmark" style={{ color: isChecked ? "green" : "#fff" }} />
                                    </label>
                                    {hasChildren && (
                                        <i
                                            style={{ marginLeft: "20px", marginTop: "5px", cursor: "pointer", fontSize: "14px" }}
                                            className={`fa fa-chevron-${parentExpanded ? "up" : "down"}`}
                                            onClick={() => this.toggleExpandGlobal(certification.competence_profile.uuid)}
                                        />
                                    )}
                                </div>
                                {parentExpanded && <CertificationsList currentProfile={currentProfile} items={certification.children} level={level + 1} />}
                            </React.Fragment>
                        );
                    })}
                </>
            );
        };

        return <CertificationsList currentProfile={this.props.competenceProfile} items={nestedCertifications} />;
    };

    selectedCertificationsChanged(oldStudents, newStudents) {
        if (oldStudents.length !== newStudents.length) {
            return true;
        }

        for (let i = 0; i < oldStudents.length; i++) {
            const oldCerts = oldStudents[i].selectedCertification;
            const newCerts = newStudents[i].selectedCertification;

            if (oldCerts.length !== newCerts.length) {
                return true;
            }

            for (let j = 0; j < oldCerts.length; j++) {
                if (oldCerts[j].value !== newCerts[j].value) {
                    return true;
                }
            }
        }

        return false;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.selectedCertificationsChanged(prevState.students, this.state.students)) {
            this.updateStudentCertifications();
        }
    }

    updateStudentCertifications = async () => {
        const requestBody = [];
        for (let student of this.state.students) {
            let products = ["certification"];

            for (let cert of student.selectedCertification) {
                requestBody.push({
                    user: student.uuid,
                    course: this.state.itemID,
                    competence_profile: cert.value,
                    products: products
                });
            }
        }

        try {
            const response = await axios.post("/v1/certifications/quote/", requestBody);

            const students = this.state.students.map((student) => {
                const selectedCertification = student.selectedCertification.map((cert) => {
                    const studentQuote = response.data.find(
                        (quote) => quote.user.uuid === student.uuid && quote.competence_profile.uuid === cert.value && quote.product === "certification"
                    );

                    if (studentQuote) {
                        cert.price = studentQuote.price;
                        cert.currency = studentQuote.currency;
                        if (studentQuote.error) cert.error = studentQuote.error;
                    }

                    return cert;
                });

                return { ...student, selectedCertification };
            });

            this.setState({ students });
        } catch (error) {
            console.error(error);
        }
    };

    fetchInsuranceQuote = async (students) => {
        let requestBody = this.state.students
            .filter((s) => s.selected_insured || s.students_options?.insured)
            .map((s) => ({
                user: s.uuid,
                course: this.state.itemID,
                competence_profile: this.state.competence_profile,
                products: ["insurance"]
            }));

        if (students.length === 1) {
            requestBody = [
                {
                    user: students[0].uuid,
                    course: this.state.itemID,
                    competence_profile: this.state.competence_profile,
                    products: ["insurance"]
                }
            ];
        }

        if (requestBody.length > 0) {
            const response = await axios.post("/v1/certifications/quote/", requestBody);

            const newStudentsState = this.state.students.map((student) => {
                const insuranceQuote = response.data.find((quote) => quote.user.uuid === student.uuid && quote.product === "insurance");
                if (insuranceQuote) {
                    student.insurance_quote = {
                        price: insuranceQuote.price,
                        currency: insuranceQuote.currency
                    };
                    if (insuranceQuote.error) student.insurance_quote.error = insuranceQuote.error;
                }

                return student;
            });
            this.setState({ students: newStudentsState });
        }
    };

    selectAllPhysicalPasses = () => {
        let { students } = this.state;

        const allChecked = students.every((student) =>
            student.selectedCertification
                .filter((cert) => !student.selectedCertification.some((c) => cert.parents.includes(c.value)))
                .every((cert) => student.physicalPasses?.find((pass) => pass.value === cert.value))
        );

        let confirmNeeded = false;
        if (!allChecked) {
            students.forEach((student) => {
                const nonDiplomaCerts = student.selectedCertification.filter(
                    (cert) =>
                        !student.selectedCertification.some((c) => cert.parents.includes(c.value)) &&
                        !student.physicalPasses?.find((pass) => pass.value === cert.value) &&
                        cert.certificate_type !== "diploma"
                );
                if (nonDiplomaCerts.length > 0) {
                    confirmNeeded = true;
                }
            });
        }

        let userConfirmed = true;
        if (confirmNeeded) {
            userConfirmed = window.confirm(
                "Let op: Je vraagt één of meerdere passen aan voor een deelmodule binnen de cursus. Volgt de cursist binnen 93 ook alle andere onderdelen binnen dit competentieprofiel, dan raden we je aan om pas daarna een plastic pas aan te vragen. De cursist beschikt dan over één volledige pas en er worden slechts eenmaal kosten in rekening gebracht."
            );
        }

        if (allChecked) {
            students = students.map((student) => {
                const updatedStudent = { ...student };
                updatedStudent.physicalPasses = [];
                return updatedStudent;
            });
        } else {
            students = students.map((student) => {
                let nonDiplomaCerts = [];
                const updatedStudent = { ...student };

                if (updatedStudent.selectedCertification.length > 0) {
                    updatedStudent.selectedCertification.forEach((cert) => {
                        if (
                            !updatedStudent.selectedCertification.some((c) => cert.parents.includes(c.value)) &&
                            !updatedStudent.physicalPasses?.find((pass) => pass.value === cert.value)
                        ) {
                            if (cert.certificate_type !== "diploma") {
                                nonDiplomaCerts.push(cert);
                            } else {
                                updatedStudent.physicalPasses = [...updatedStudent.physicalPasses, cert];
                            }
                        }
                    });
                }

                if (userConfirmed && nonDiplomaCerts.length > 0) {
                    updatedStudent.physicalPasses = [...updatedStudent.physicalPasses, ...nonDiplomaCerts];
                }

                return updatedStudent;
            });
        }

        this.setState({ students });
    };

    selectAllAdditionalProduct = (product) => {
        const allSelected = this.state.students.every((s) => s[product] === true);

        const students = this.state.students.map((student) => ({
            ...student,
            [product]: allSelected ? false : true
        }));

        this.setState({ students }, () => {
            if (product === "selected_insured") {
                this.fetchInsuranceQuote(this.state.students);
            }
        });
    };

    formatCurrency = (value) => {
        if (!value) return "";

        const isRounded = Number.isInteger(value);

        if (isRounded) {
            return `${value},-`;
        } else {
            return `${value.toFixed(2).replace(".", ",")}`;
        }
    };

    render = () => {
        return (
            <>
                <div>
                    {this.state.loading ? (
                        <Loader />
                    ) : (
                        <form ref="formref">
                            <div className="finalize-stepper">
                                <div
                                    className={cx("stepper-item", { current: this.state.activeChapter === 1 }, { active: this.state.activeChapter > 1 })}
                                    onClick={() => this.setState({ activeChapter: 1 })}
                                >
                                    <div>
                                        <span className="stepper-number">1</span>Selecteer
                                    </div>
                                </div>
                                <div
                                    className={cx("stepper-item", { current: this.state.activeChapter === 2 }, { active: this.state.activeChapter > 2 })}
                                    onClick={() => {
                                        if (this.state.activeChapter === 1) {
                                            if (!this.state.students.every((student) => student.checkedForSubmit)) {
                                                this.setState({ confirmationPromptStepTwoVisible: true });
                                                return;
                                            }
                                        }
                                        this.setState({ activeChapter: 2 }, () => this.fetchInsuranceQuote(this.state.students));
                                    }}
                                >
                                    <div>
                                        <span className="stepper-number">2</span>Overzicht
                                    </div>
                                </div>
                                <div
                                    className={cx("stepper-item", { current: this.state.activeChapter === 3 }, { active: this.state.activeChapter > 3 })}
                                    onClick={() => {
                                        if (this.state.activeChapter === 1) {
                                            if (!this.state.students.every((student) => student.checkedForSubmit)) {
                                                this.setState({ confirmationPromptStepTwoVisible: true });
                                                return;
                                            }
                                        }
                                        this.setState({ activeChapter: 3 });
                                    }}
                                >
                                    <div>
                                        <span className="stepper-number">3</span>Afronden
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <FormErrorHandler fieldName="all" errorObject={this.state.errorMessage} />
                            </div>
                            {this.state.activeChapter === 1 && (
                                <div className="row">
                                    <div className="col-12">
                                        {this.state.students.length > 0 && <FinalizeLegend />}
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="overview-redux__head overview-redux__head--bulk-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            title="Selecteer alle huidige items"
                                                            className="checkbox checkbox--no-label"
                                                            onChange={this.checkAllStudents}
                                                            checked={this.state.allStudentsChecked}
                                                        />
                                                    </th>
                                                    <th>NIBHV nummer</th>
                                                    <th>Naam</th>
                                                    <th>Geboortedatum</th>
                                                    <th style={{ minWidth: "600px" }}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                            <div>
                                                                Certificering
                                                                {this.renderGlobalCheckboxes(
                                                                    this.state.allCertifications,
                                                                    this.state.selectedGlobalCertification,
                                                                    this.handleChangeGlobalSelect
                                                                )}
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.students.map((student) => {
                                                    return (
                                                        <tr key={student.uuid}>
                                                            <td className="overview-table__cell overview-table__cell--row-selected">
                                                                <input
                                                                    onChange={(e) => this.studentChecked(e, student.uuid)}
                                                                    checked={student.checkedForSubmit}
                                                                    type="checkbox"
                                                                    className="checkbox checkbox--no-label"
                                                                />
                                                            </td>
                                                            <td>{student.nibhv_number}</td>
                                                            <td>{student.full_name}</td>
                                                            <td>{moment(student.date_of_birth).format("DD-MM-YYYY")}</td>
                                                            <td style={{ minWidth: "600px" }}>
                                                                {/*[Current: {this.props.competenceProfile.name} lang: {this.props.competenceProfile.language} tags:{this.props.competenceProfile.tags.join(", ")}]*/}
                                                                {this.renderStudentCheckboxes(
                                                                    student.available_certifications,
                                                                    student.selectedCertification,
                                                                    student.uuid,
                                                                    this.handleChangeSelect
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <div className="col-12">
                                        <div className="form-group" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginRight: "20px" }}>
                                            <button
                                                disabled={!this.state.students.some((student) => student.checkedForSubmit)}
                                                className="btn btn-primary"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (!this.state.students.every((student) => student.checkedForSubmit)) {
                                                        this.setState({ confirmationPromptStepTwoVisible: true });
                                                        return;
                                                    }
                                                    this.setState({ activeChapter: 2 }, () => this.fetchInsuranceQuote(this.state.students));
                                                }}
                                            >
                                                Volgende
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                    )}
                </div>

                {this.state.activeChapter === 2 && (
                    <div>
                        <div className="col-12">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Naam</th>
                                        <th>Certificering</th>
                                        <th>
                                            <div>
                                                <i
                                                    style={{ backGroundColor: "#f60", margin: 5, float: "left" }}
                                                    className="fa fa-check save-all-exemptions-icon"
                                                    onClick={this.selectAllPhysicalPasses}
                                                />
                                            </div>
                                            Fysieke pas <i className="fa fa-credit-card" />
                                        </th>
                                        {this.state.courseInsuranceAvailable && (
                                            <th>
                                                <div>
                                                    <i
                                                        style={{ backGroundColor: "#f60", margin: 5, float: "left" }}
                                                        className="fa fa-check save-all-exemptions-icon"
                                                        onClick={() => this.selectAllAdditionalProduct("selected_insured")}
                                                    />
                                                </div>
                                                Verzekerd <i className="fa fa-shield" />
                                            </th>
                                        )}
                                        {this.props.allowEmployerSpecific && (
                                            <th>
                                                <div>
                                                    <i
                                                        style={{ backGroundColor: "#f60", margin: 5, float: "left" }}
                                                        className="fa fa-check save-all-exemptions-icon"
                                                        onClick={() => this.selectAllAdditionalProduct("selected_employer_specific")}
                                                    />
                                                </div>
                                                Bedrijfsspecifiek <i className="fa fa-building" />
                                            </th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.students
                                        .filter((s) => s.checkedForSubmit === true)
                                        .map((student) => {
                                            return (
                                                <tr key={student.uuid}>
                                                    <td>{student.full_name}</td>
                                                    {student.selectedCertification.length > 0 ? (
                                                        <td>
                                                            {student.selectedCertification.map((cert, index) => {
                                                                return <div key={`${cert.label} - ${index}`}>{cert.label}</div>;
                                                            })}
                                                        </td>
                                                    ) : (
                                                        <td style={{ color: "red" }}>
                                                            Er is geen certificering geselecteerd voor deze cursist.
                                                            <i className="fa fa-info-circle" data-tip data-for={`tip-${this.state.courseID}-2`} />
                                                            <ReactTooltip id={`tip-${this.state.courseID}-2`} effect="solid" place="right">
                                                                Er zal geen certificering worden gegenereerd voor deze cursist.
                                                            </ReactTooltip>
                                                        </td>
                                                    )}
                                                    <td>
                                                        {student.selectedCertification.length > 0
                                                            ? student.selectedCertification.map((cert) =>
                                                                  !student.selectedCertification.some((c) => cert.parents.includes(c.value)) ? (
                                                                      <div key={cert.value}>
                                                                          <input
                                                                              type="checkbox"
                                                                              style={{ marginLeft: "50px" }}
                                                                              className="checkbox checkbox--no-label"
                                                                              onChange={(e) => {
                                                                                  if (e.target.checked && cert.certificate_type !== "diploma") {
                                                                                      const userConfirmed = window.confirm(
                                                                                          "Let op: Als je een plastic pas aanvraagt voor een deelmodule binnen de bhv cursus en volgt de cursist binnen 93 ook ook alle andere onderdelen van deze cursus, dan raden we je aan om pas daarna een fysieke pas aan te vragen. De cursist beschikt dan over één volledige pas en er worden slechts eenmaal kosten in rekening gebracht."
                                                                                      );
                                                                                      if (userConfirmed) {
                                                                                          this.checkPhysicalPass(e, cert, student.uuid);
                                                                                      } else {
                                                                                          e.target.checked = false;
                                                                                      }
                                                                                  } else {
                                                                                      this.checkPhysicalPass(e, cert, student.uuid);
                                                                                  }
                                                                              }}
                                                                              checked={!!student.physicalPasses?.find((pass) => pass.value === cert.value)}
                                                                          />
                                                                      </div>
                                                                  ) : null
                                                              )
                                                            : null}
                                                    </td>
                                                    {this.state.courseInsuranceAvailable && (
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="checkbox checkbox--no-label"
                                                                style={{ marginLeft: "50px" }}
                                                                checked={!!student?.selected_insured}
                                                                onChange={(e) => this.studentInsuredChecked(e, student.uuid)}
                                                            />
                                                        </td>
                                                    )}
                                                    {this.props.allowEmployerSpecific && (
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="checkbox checkbox--no-label"
                                                                style={{ marginLeft: "60px" }}
                                                                onChange={(e) => this.studentEmployerSpecificChecked(e, student.uuid)}
                                                                checked={!!student?.selected_employer_specific}
                                                            />
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>

                        <div className="row confirm-finalize-buttons-container" style={{ marginRight: "20px" }}>
                            <div className="mt-4">
                                <button className="btn float-right btn-primary no-sideflap" onClick={() => this.setState({ activeChapter: 1 })}>
                                    Vorige
                                </button>
                            </div>
                            <div className="mt-4">
                                <button className="btn float-right btn-primary" onClick={() => this.setState({ activeChapter: 3 })}>
                                    Volgende
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.activeChapter === 3 && (
                    <div>
                        <div className="col-12 finalize-status-container">
                            <span>Status: </span>
                            <span style={{ marginLeft: "13px" }} className={"course-status-indicator course-status-indicator--" + this.state.course_state}>
                                <b>{courseStateNames?.find((item) => item.slug === this.state.course_state)?.name.toUpperCase()}</b>
                            </span>
                        </div>

                        {/* <div className="col-12 complete-course-toggle">
                            <span>Stuur e-mail naar studenten: &nbsp;</span>
                            <i className="fa fa-info-circle" data-tip data-for={`tip-${this.state.courseID}-2`} />
                            <ReactTooltip id={`tip-${this.state.courseID}-2`} effect="solid" place="right">
                                Stuurt een e-mail naar de cursisten met bericht over de certificering
                            </ReactTooltip>
                            <i
                                className={cx("fa toggle-button", this.state.sendEmail ? "fa-toggle-on" : "fa-toggle-off")}
                                onClick={() =>
                                    this.setState((state) => ({
                                        sendEmail: !state.sendEmail
                                    }))
                                }
                            ></i>
                        </div> */}

                        <div>
                            <h4 style={{ marginLeft: "15px", marginTop: "10px", fontWeight: "700" }}>
                                <b>Huidige wijzigingen</b>
                            </h4>
                            <div className="col-12">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Naam</th>
                                            <th>Cursus producten</th>
                                            <th>Type</th>
                                            <th>Kosten (Excl.BTW)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.students
                                            .filter((s) => s.checkedForSubmit === true)
                                            .map((student) => {
                                                return (
                                                    <tr key={student.uuid} style={{ borderBottom: this.state.students > 1 ? "1px solid #ccc" : "" }}>
                                                        <td>{student.full_name}</td>
                                                        <td>
                                                            {student.selectedCertification.length > 0 ? (
                                                                student.selectedCertification.map((cert, index) => (
                                                                    <React.Fragment key={`${cert.label} - ${index}`}>
                                                                        <div>{cert.label}</div>
                                                                        {student.physicalPasses.map((pass) => {
                                                                            if (pass.value === cert.value) {
                                                                                return (
                                                                                    <div key={pass.value} style={{ marginLeft: "20px", fontSize: "0.8em" }}>
                                                                                        <li>Fysieke pas geselecteerd </li>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </React.Fragment>
                                                                ))
                                                            ) : (
                                                                <div style={{ color: "red" }}>
                                                                    Er is geen certificaat geselecteerd voor deze cursist.
                                                                    <i className="fa fa-info-circle" data-tip data-for={`tip-${this.state.courseID}-2`} />
                                                                    <ReactTooltip id={`tip-${this.state.courseID}-2`} effect="solid" place="right">
                                                                        Er zal geen certificaat worden gegenereerd voor deze cursist.
                                                                    </ReactTooltip>
                                                                </div>
                                                            )}
                                                            {student.insurance_quote && student.selected_insured && "Verzekering"}
                                                        </td>
                                                        <td>
                                                            {student.selectedCertification.length > 0 &&
                                                                student.selectedCertification.map((cert, index) => (
                                                                    <React.Fragment key={`${cert.label} - ${index}`}>
                                                                        <div>
                                                                            <CertificateType type={cert.certificate_type} />
                                                                        </div>
                                                                        {student.physicalPasses.map((pass) => {
                                                                            if (pass.value === cert.value) {
                                                                                return (
                                                                                    <div key={pass.value} style={{ marginLeft: "20px", fontSize: "0.8em" }}>
                                                                                        <li>Fysieke pas</li>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </React.Fragment>
                                                                ))}
                                                        </td>
                                                        <td>
                                                            {student.selectedCertification.length > 0 ? (
                                                                student.selectedCertification.map((cert, index) => (
                                                                    <React.Fragment key={`${cert.label} - ${index}`}>
                                                                        {!cert.error ? (
                                                                            <div>
                                                                                {this.formatCurrency(cert.price)} {cert.currency}
                                                                            </div>
                                                                        ) : (
                                                                            cert.error === "No price available for this item." && (
                                                                                <div>Geen prijs beschikbaar voor dit artikel</div>
                                                                            )
                                                                        )}
                                                                        {student.physicalPasses.map((pass) => {
                                                                            if (pass.value === cert.value) {
                                                                                return (
                                                                                    <div key={pass.value} style={{ marginLeft: "20px", fontSize: "0.8em" }}>
                                                                                        <li>
                                                                                            {pass.price
                                                                                                ? `${this.formatCurrency(pass.price)} ${pass.currency}`
                                                                                                : "Fout bij het verkrijgen van prijs"}
                                                                                        </li>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </React.Fragment>
                                                                ))
                                                            ) : (
                                                                <div></div>
                                                            )}
                                                            {student.insurance_quote && student.selected_insured ? (
                                                                <React.Fragment key={`${student.uuid} - insurance`}>
                                                                    {!student.insurance_quote.error ? (
                                                                        <div>
                                                                            {this.formatCurrency(student.insurance_quote.price)} {student.insurance_quote.currency}
                                                                        </div>
                                                                    ) : (
                                                                        student.insurance_quote.error === "No price available for this item." && (
                                                                            <div>Geen prijs beschikbaar voor dit artikel</div>
                                                                        )
                                                                    )}
                                                                </React.Fragment>
                                                            ) : null}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row confirm-finalize-buttons-container">
                            <div className="mt-4">
                                <button
                                    disabled={this.state.submitting}
                                    className="btn float-right btn-primary no-sideflap"
                                    onClick={() => {
                                        this.setState({ activeChapter: 2 }, () => this.fetchInsuranceQuote(this.state.students));
                                    }}
                                >
                                    Vorige
                                </button>
                            </div>
                            <div className="mt-4" style={{ marginRight: "20px" }}>
                                <a
                                    href={`mailto:support@nibhv.nl?cc=aarsbergen@nibhv.nl,kapiteijn@nibhv.nl,neville@digitalimpact.nl&subject=Controle%20vereist%20voor%20certificering&body=Beste%2C%0D%0A%0D%0AVoor%20${this.state.courseID}%20is%20er%20certificering%20aangevraagd.%20Voor%20deze%20aanvraag%20is%20er%20een%20controle%20vereist%20voorafgaand%20aan%20het%20certificeren.`}
                                >
                                    <button className="btn btn-primary no-sideflap">Rapporteer</button>
                                </a>
                                <button
                                    disabled={this.state.submitting}
                                    style={{ marginLeft: "30px" }}
                                    className="btn float-right btn-primary"
                                    onClick={this.handleSubmit}
                                >
                                    Afronden
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.confirmationPromptStepTwoVisible && (
                    <Dialog
                        title="Klopt het dat u één of meerdere cursisten niet heeft geselecteerd?"
                        onClose={() => this.setState({ confirmationPromptStepTwoVisible: false })}
                        visible={this.state.confirmationPromptStepTwoVisible}
                        animation="fade"
                        footer={[
                            <button
                                type="button"
                                className="btn btn-secondary"
                                key="no"
                                onClick={() => {
                                    this.setState({ confirmationPromptStepTwoVisible: false });
                                }}
                            >
                                Nee
                            </button>,
                            <button
                                type="button"
                                className="btn btn-primary"
                                key="yes"
                                onClick={() => {
                                    this.setState({ confirmationPromptStepTwoVisible: false, activeChapter: 2 }, () => this.fetchInsuranceQuote(this.state.students));
                                }}
                            >
                                Ja
                            </button>
                        ]}
                    ></Dialog>
                )}
                {this.state.submitting && (
                    <Dialog
                        title="De aangevraagde certificaten worden verwerkt. Het kan maximaal 15 minuten duren voordat alle certificeringen beschikbaar zijn. Zodra de opdracht is afgerond ontvang je hierover een e-mail."
                        noClose={true}
                        visible={this.state.submitting}
                        animation="fade"
                    >
                        <Loader />
                    </Dialog>
                )}
            </>
        );
    };
}
